import React, {FC} from "react";
import cls from "../shop.module.scss";
import Link from "next/link";
import {TranslationsType} from "../../../types/homePageTypes";

const CartIsEmpty:FC<{translationsData: TranslationsType}> = ({translationsData}) => {
    return (
        <div className={`${cls.block} ${cls["block-empty"]}`}>
            <div className="container">
                <div className={`${cls["block-empty__body"]} ${cls["block-empty-fms"]}`}>
                    <h2 className={cls["text-center"]}>{translationsData.CartEmpty}</h2>
                    <div className={cls["block-empty__actions"]}>
                        <Link href="/">
                            <a className="btn btn-orange btn-primary f16">
                                {translationsData.Continue}
                            </a>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CartIsEmpty